import { Box, Button, Icon, SimpleGrid, Stack, Text } from '@chakra-ui/react';
import { useFilters } from '~/hooks/useFilters';
import { useHomesStore } from '~/store/useHomesStore';
import { getFilterArrayValues } from '@habity/services';
import { NestedStatus } from '@habity/types';
import { useAgency } from '~/hooks/useAgency';
import { useTranslations } from 'next-intl';

export const Statuses = ({
  signedIn,
  ignoreSearch = false,
  hideTitle = false,
}: {
  signedIn: boolean;
  ignoreSearch?: boolean;
  hideTitle?: boolean;
}) => {
  const filters = useHomesStore((state) => state.filters);
  const { performSearch } = useFilters();
  const {
    publicStatuses,
    signedInStatuses,
    statuses: appStatuses,
    getStatusIcon,
  } = useAgency();
  const t = useTranslations('Status');

  const { statuses } = filters || {};

  const onToggle = (status: NestedStatus) => {
    const { name } = status;
    const newStatuses = getFilterArrayValues(name, statuses);
    performSearch({ filters: { statuses: newStatuses }, ignoreSearch });
  };

  const statusList = signedIn ? signedInStatuses : publicStatuses;

  return (
    <Stack spacing="2">
      {!hideTitle && (
        <Text size="md" fontWeight="medium">
          Status
        </Text>
      )}
      <SimpleGrid minChildWidth="150px" rowGap="2" columnGap="2">
        {statusList
          ?.toSorted((a, b) => a.id - b.id)
          ?.map((status) => {
            const isActive = statuses?.includes(status.name);
            const statusIcon = getStatusIcon(status?.name);
            return (
              <Button
                key={status.name}
                flex="1"
                size="md"
                fontSize="sm"
                variant="outline"
                h="80px"
                borderColor="blackAlpha.400"
                onClick={() => onToggle(status)}
                isActive={isActive}
                _active={{
                  backgroundColor: 'blackAlpha.50',
                  borderColor: 'black',
                  borderWidth: '2px',
                }}
              >
                <Stack justifyContent="center" alignItems="center" spacing="2">
                  {statusIcon ? (
                    <Icon boxSize="24px" as={statusIcon} />
                  ) : (
                    <Box
                      borderRadius="full"
                      boxSize="24px"
                      bgColor={
                        appStatuses?.find((s) => s.name === status.name)
                          ?.color_hex
                      }
                    />
                  )}
                  <Text size="sm">{t(`${status.name}.title`)}</Text>
                </Stack>
              </Button>
            );
          })}
      </SimpleGrid>
    </Stack>
  );
};
